<template>
    <div>
        <div
            id="content"
            class="content animated slideInRight delay-1s"
        >
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                Visualização de Veículo
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-8">
                                    <form action>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="brand">
                                                        Marca:
                                                    </label>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        v-model="vehicle.brand"
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="model">
                                                        Modelo:
                                                    </label>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        v-model="vehicle.model"
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="color">
                                                        Cor:
                                                    </label>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        v-model="vehicle.color"
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="board">
                                                        Placa:
                                                    </label>
                                                    <input
                                                        style="text-transform: uppercase;"
                                                        type="text"
                                                        class="form-control"
                                                        v-mask="'AAA#X##'"
                                                        v-model="vehicle.board"
                                                        disabled
                                                    />
                                                </div>
                                            </div>

                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="type">
                                                        Tipo:
                                                    </label>
                                                    <select
                                                        v-model="vehicle.vehicle_type_id"
                                                        class="form-control"
                                                        disabled
                                                    >
                                                        <option
                                                            v-for="type in types"
                                                            :value="type.id"
                                                            :key="type.id"
                                                        >{{ type.description }}
                                                        </option
                                                        >
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="combustible">
                                                        Combustível:
                                                    </label>
                                                    <select
                                                        v-model="vehicle.combustible"
                                                        class="form-control"
                                                        id="combustible"
                                                        name="combustible"
                                                        tabindex="5"
                                                        disabled
                                                    >
                                                        <option value="Etanol">Etanol</option>
                                                        <option value="Gasolina">Gasolina</option>
                                                        <option value="Flex">Flex</option>
                                                        <option value="GNV">GNV</option>
                                                        <option value="Diesel">Diesel</option>
                                                    </select>
                                                </div>
                                            </div>


                                        </div>
                                    </form>
                                </div>
                                <div class="col-md-4">
                                    <div class="car-img">
                                        <img
                                            :src="vehicle.photo"
                                            class="car"
                                            alt="Imagem do Veículo"
                                        />
                                        <qrcode-vue
                                            v-if="vehicle.board"
                                            class="code"
                                            :value="vehicle.board"
                                            level="H"
                                        ></qrcode-vue>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="renavam_code">Código Renavam:</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-mask="'###########'"
                                            v-model="vehicle.renavam_code"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="chassi">Chassi:</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="vehicle.chassi"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for="current_km">
                                            KM Atual:
                                        </label>
                                        <the-mask
                                            disabled
                                            class="form-control"
                                            v-model="vehicle.current_km"
                                            :mask="['####', '#.###', '##.###', '###.###']"
                                        />
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for="year_of_manufacture">
                                            Ano Fab:
                                        </label>
                                        <input
                                            type="text"
                                            v-mask="'####'"
                                            class="form-control"
                                            v-model="vehicle.year_of_manufacture"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for="model_year">
                                            Ano Mod:
                                        </label>
                                        <input
                                            type="text"
                                            v-mask="'####'"
                                            class="form-control"
                                            v-model="vehicle.model_year"
                                            disabled
                                        />
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="branch_id">
                                            Filial:
                                        </label>
                                        <select
                                            v-model="vehicle.branch_id"
                                            class="form-control"
                                            disabled
                                        >
                                            <option
                                                v-for="branch in branches"
                                                :value="branch.id"
                                                :key="branch.id"
                                            >{{ branch.description }}
                                            </option
                                            >
                                        </select>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="color">
                                            Centro de Custo:
                                        </label>
                                        <select
                                            v-model="vehicle.cost_center_id"
                                            class="form-control"
                                            disabled
                                        >
                                            <option
                                                v-for="cost_center in cost_centers"
                                                :value="cost_center.id"
                                                :key="cost_center.id"
                                            >{{ cost_center.description }}
                                            </option
                                            >
                                        </select>
                                        <span class="text-muted"  style="font-size: 12px">
                                            Se o campo ficar em branco o veículo é compartilhado
                                        </span>
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="description">
                                            Descrição:
                                        </label>
                                        <textarea
                                            disabled
                                            class="form-control"
                                            v-model="vehicle.description"
                                            rows="6"
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12">

                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                Últimas Viagens Realizadas
                            </div>
                        </div>
                        <div>
                            <base-crud
                                :table="table"
                                :columns="columns"
                                :options="options"
                                :endPoint="endPoint"
                                :enableAdd="false"
                                :enableEdit="false"
                                :customFilters="customFilters"
                                :enableDelete="false"
                                :enableView="false"
                                @filteredRetreat="filteredRetreat"
                                @filteredDevolution="filteredDevolution"
                                @filteredCreated="filteredCreated"
                            ></base-crud>
                        </div>
                    </div>
                </div>


                <div class="col-12">

                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                Logs de Bloqueios e Desbloqueios
                            </div>
                        </div>
                        <div>

                            <base-crud
                                :table="tableLogs"
                                :columns="columnsLogs"
                                :options="optionsLogs"
                                endPoint="vehicle-logs"
                                :enableAdd="false"
                                :enableEdit="false"
                                :enableDelete="false"
                                :enableView="false"
                            ></base-crud>
                        </div>
                    </div>

                    <div class="block text-right">
                        <router-link
                            to="/vehicles"
                            class="btn btn-back"
                        >
                            <i class="fa fa-arrow-left mr-2"></i>
                            Voltar
                        </router-link>
                        <br/>
                        <br/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
import QrcodeVue from "qrcode.vue";
import {addZeros} from "../../composables/functions";
import {getMessage} from "../../composables/message";

export default {
    data() {
        return {
            url: '',
            previewImage: null,
            // Filtros customizados
            retreat_date: '',
            devolution_date: '',
            created_at: '',
            vehicle: {
                description: "",
                board: "",
                branch_id: "",
                brand: "",
                color: "",
                model: "",
                year_of_manufacture: "",
                model_year: "",
                renavam_code: "",
                chassi: "",
                combustible: "",
                current_km: "",
                photo: "",
                vehicle_qr_code_photo: "",
                category_id: "",
                vehicle_type_id: ""
            },
            checklist_item: {
                id: "",
                description: "",
                checked: ""
            },
            checklist_items: [],
            link_checklist_items: [],
            categories: [],
            casters: [],
            branches: [],
            types: [],
            cost_centers: [],
            reserve: {
                user: {
                    name: ""
                },
                branch: {
                    description: ""
                },
                vehicle_type_id: {
                    description: ""
                },
                reserve_status: {
                    title: ""
                },
                vehicles: {
                    description: "",
                    board: ""
                }
            },

            //Base Crud
            customFilters: [
                {
                    name: "retreat_date",
                    type: "calendar",
                    call: "filteredRetreat"
                },
                {
                    name: "devolution_date",
                    type: "calendar",
                    call: "filteredDevolution"
                },
                {
                    name: "created_at",
                    type: "calendar",
                    call: "filteredCreated"
                }
            ],
            extra: [{}],
            table: "reservesTable",
            tableLogs: "logsTable",
            pages: [],
            columns: [
                "user_id",
                "retreat_date",
                "devolution_date",
                "created_at",
                // "actions",
            ],
            columnsLogs: ["description", "created_at"],
            tableData: ["id"],
            debounce: 800,
            options: {
                filterByColumn: true,
                filterable: ["user_id"],
                sortable: ["user_id", "retreat_date", "devolution_date", "created_at"],
                pagination: {chunk: 10, dropdown: false, nav: "scroll"},
                perPage: 10,
                perPageValues: [10, 25, 50, 100],
                headings: {
                    user_id: "Responsável",
                    retreat_date: "Data de Retirada",
                    devolution_date: "Data de Devolução",
                    created_at: "Reservado em",
                    actions: "Ações"
                },
                templates: {
                    user_id: function (h, row, index) {
                        return row.user ? row.user.name : "Sem Nome";
                    }
                },
                requestFunction: function (data) {
                    let requestData = {};

                    let query = this.$parent.$parent.query(data.query);
                    requestData.params = data;
                    requestData.params.query = "";
                    requestData.params.with = ["user"];

                    // Adicionar filtros customizados
                    if (this.$parent.$parent.retreat_date != null && this.$parent.$parent.retreat_date != "") {
                        requestData.params.retreat_date = this.$parent.$parent.retreat_date;
                    }
                    if (this.$parent.$parent.devolution_date != null && this.$parent.$parent.devolution_date != "") {
                        requestData.params.devolution_date = this.$parent.$parent.devolution_date;
                    }
                    if (this.$parent.$parent.created_at != null && this.$parent.$parent.created_at != "") {
                        requestData.params.created_at = this.$parent.$parent.created_at;
                    }

                    return this.$http.get(this.url + "?" + query, requestData).catch(
                        function (e) {
                            this.dispatch("error", e);
                        }.bind(this)
                    );
                }
            },
            endPoint: "reserveVehicles/",


            optionsLogs: {
                filterByColumn: true,
                filterable: ["user_id"],
                sortable: ['description', "created_at"],
                pagination: {chunk: 10, dropdown: false, nav: "scroll"},
                perPage: 10,
                perPageValues: [10, 25, 50, 100],
                headings: {
                    description: "Descrição",
                    created_at: "Data",
                },
                templates: {
                    created_at: function (h, row, index) {
                        const date = new Date(row.created_at)
                        return `${addZeros(date.getDate())}/${addZeros(date.getMonth() + 1)}/${date.getFullYear()} ${addZeros(date.getHours())}:${addZeros(date.getMinutes())}:${addZeros(date.getSeconds())}`;
                    }
                },

                requestFunction: function (data) {
                    let requestData = {};
                    const id = this.$route.params.id

                    let query = this.$parent.$parent.query(data.query);
                    requestData.params = data;
                    requestData.params.query = "";
                    requestData.params.with = ["user"];

                    return this.$http.get(this.url + "?vehicle_id=" + id + query, requestData).catch(
                        function (e) {
                            this.dispatch("error", e);
                        }.bind(this)
                    );
                }
            },
        };
    },
    methods: {
        query: function (query) {
            let columns = {
                user_id: "user[name]",
                retreat_date: "retreat_date",
                devolution_date: "devolution_date"
            };
            let filters =
                "&orderByDesc=created_at&vehicle_id=" + this.$route.params.id;

            // Adicionar filtros da tabela
            $.each(query, function (index, value) {
                filters += columns[index] + "=" + value + "&";
            });

            // Adicionar filtros customizados (não incluído aqui pois será feito na requestFunction)

            return filters;
        },

        // Métodos para capturar eventos dos filtros customizados
        filteredRetreat(date) {
            this.retreat_date = date;
        },
        filteredDevolution(date) {
            this.devolution_date = date;
        },
        filteredCreated(date) {
            this.created_at = date;
        },

        getVehicle: function (id) {
            const self = this;
            const api = self.$store.state.api + "vehicles/" + id;

            self.$http
                .get(api)
                .then(response => {
                    self.vehicle = response.data.data[0];
                    self.vehicle = response.data.data[0];
                })
                .catch(error => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
        getBranches: function (id) {
            const self = this;
            const api = self.$store.state.api + "branches/";

            self.$http
                .get(api)
                .then(response => {
                    self.branches = response.data.data;
                })
                .catch(error => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
        getTypes: function (id) {
            const self = this;
            const api = self.$store.state.api + "vehicleTypes/";

            self.$http
                .get(api)
                .then(response => {
                    self.types = response.data.data;
                })
                .catch(error => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
        fetch(url) {
            const self = this;
            const api = self.$store.state.api + url + '?paginated=false';

            return self.$http
                .get(api)
                .then((response) => {
                    return  response.data.data;
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                    return [];
                });
        },
        getDatas() {
            const self = this;
            Promise.all([
                self.fetch('cost-centers'),
            ]).then(([costCenters]) => {
                self.cost_centers = costCenters;
            }).catch((error) => {
                console.error("Erro ao buscar dados:", error);
            });
        }
    },
    computed: {
        filteredCasters: function () {
            if (this.vehicle.board.length >= 7) {
                var end_plate = this.vehicle.board.charAt(
                    this.vehicle.board.length - 1
                );
                return this.casters.filter(x => x.end_plate == end_plate);
            }
        }
    },
    mounted: function () {
        const self = this;
        self.getDatas();
        self.getBranches();
        self.getTypes();
        let id = self.$route.params.id;
        if (id) {
            self.getVehicle(id);
        }

        $("html, body").scrollTop(0);
    },
    components: {
        BaseCrud,
        QrcodeVue
    }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/Vehicle/View.vue